<template>
  <div :class="SelectClass()" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="f-List foo2">
      <vue-custom-scrollbar
        class="scroll-area fullHeight"
        :settings="settings"
        @ps-scroll-y="scrollHanle"
        v-chat-scroll
      >
        <ul>
          <li
            v-for="(detail,index) in FriendList.filter(data => this.searchFilter(data))"
            :class="detail.isFavorite?'act isFavorite':''"
            draggable="true"
            @dragstart="dragStart($event, detail)"
            @dragend="dragend($event, detail)"
          >
            <img
              v-bind:src="detail.imgUrl"
              onerror="javascript:this.src='../static/img/avatar-default.jpg'"
            />
            <div class="listDesc" @click="openFriend(detail.socialLeadId, detail.preferChatRoomId)">
              <h3>{{detail.name}} / {{detail.leadName}}</h3>
              <div class="leadEnglishName" v-if="detail.leadEnglishName">({{detail.leadEnglishName}})</div>
              <div class="unread" v-if="detail.UnreadCount != ''">
                <span>{{detail.UnreadCount}}</span>
              </div>
              <div class="tag" v-if="detail.tagName != ''">{{detail.tagName}}</div>
              <div class="tag" v-if="detail.ListClass != ''">{{detail.ListClass}}</div>
            </div>
            <div class="listRight">
              <div class="star" @click="addFavorite(index,detail)"></div>
              <h5
                class="listDate"
                v-if="detail.messageDate != ''"
              >{{convertDate(detail.messageDate)}}</h5>
            </div>
          </li>
        </ul>
      </vue-custom-scrollbar>
    </div>
    <div class="f-head">
      <input type="text" style="margin-right: 5px;" placeholder="搜尋好友..." v-model="SearchText" />
      <b-badge variant="secondary">
        <span style="font-size: initial;">好友數:{{FriendList.length}}</span>
      </b-badge>
    </div>
    <div
      :class="showTrashCan"
      class="trashCanDiv"
      @dragover="allowDrop($event)"
      @drop="drop($event)"
      @dragenter="dragenter($event)"
    >
      <img class="trashCanImg" src="../../../static/img/trash-bucket.svg" />
    </div>
  </div>
</template>

<script>
import { FriendListHandler } from "@/handler/FriendListHandler.js";
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import store from "@/vuex/store_friendList.js";
import { isMobile } from "mobile-device-detect";
import { FriendDetailHandler } from "@/handler/FriendDetailHandler.js";

export default {
  name: "FriendList",
  props: ["mode", "group"],
  data() {
    return {
      SearchText: "",
      fullscreenLoading: false,
      token: "",
      showTrashCan: "dontShow",
      settings: {
        maxScrollbarLength: 60
      }
    };
  },
  created() {
    //todo 之後要調整為手機版與電腦版拿好有清單的方式統一從sessionStorage裡面拿，改掉這邊的客製化。
    if (this.mode != undefined && this.mode.type == "Mobile") {
      this.initializeMobileData();
      return;
    }
    if (this.mode != undefined && this.mode.type == "PC") {
      this.initializePcData();
      return;
    }
    if (this.mode == undefined) {
      this.initializeDefaultData();
      return;
    }
  },
  methods: {
    initializeMobileData: function() {
      this.token = this.mode.token;
      this.staff = this.mode.staff;
    },
    initializePcData: function() {
      this.token = this.mode.token;
      this.staff = this.GetLoginStaff();
      this.getList();
    },
    initializeDefaultData: function() {
      this.token = this.$route.query.token;
      this.staff = this.GetLoginStaff();
      this.getList();
    },
    convertDate: function(date) {
      if (date == "") return "";
      return this.convertUTCDateToLocalDate(date).substr(5, 11);
    },
    getList: function() {
      // loading data
      //var result = [];
      //this.fullscreenLoading = true;
      //取得好友清單(取得預設清單)
      //FriendListHandler.GetFriendList(this.token);
      //this.fullscreenLoading = false;
    },
    openFriend: function(socialLeadId, chatRoomId) {
      if (this.mode.type == "Mobile") {
        FriendDetailHandler.getChatRoomUrl(chatRoomId, this.token);
      } else {
        store.dispatch("selectSocialLead", { socialLeadId, chatRoomId });
      }
    },
    searchFilter: function(data) {
      var match =
        !this.SearchText ||
        data.name.toLowerCase().indexOf(this.SearchText.toLowerCase()) >= 0 ||
        data.leadName.toLowerCase().indexOf(this.SearchText.toLowerCase()) >=
          0 ||
        (data.leadEnglishName || "")
          .toLowerCase()
          .indexOf(this.SearchText.toLowerCase()) >= 0 ||
        data.tagName.toLowerCase().indexOf(this.SearchText.toLowerCase()) >=
          0 ||
        data.ListClass.toLowerCase().indexOf(this.SearchText.toLowerCase()) >=
          0;
      return match;
    },
    addFavorite: function(index, item) {
      this.FriendList[index].isFavorite = !item.isFavorite;
      FriendListHandler.AddFavorite(item.socialLeadId, this.staff.staffid);
    },
    dragStart(e, detail) {
      e.dataTransfer.setData("socialLeadId", detail.socialLeadId);
      e.dataTransfer.setData(
        "socialLeadName",
        detail.name + "/" + detail.leadName
      );

      //出現垃圾桶
      var nodrop =
        this.group.GroupSysType != undefined &&
        this.group.GroupSysType.length > 0;

      if (
        this.group.GroupSysType == "noanswer" ||
        this.group.GroupSysType == "unknownmotivation"
      ) {
        nodrop = false;
      }

      if (!nodrop) {
        e.dataTransfer.setData("trashCanGroupId", this.group.Id);
        e.dataTransfer.setData("trashCanGroupName", this.group.GroupName);
        this.showTrashCan = "show";
      }
    },
    dragend(e, detail) {
      this.showTrashCan = "dontShow";
    },
    drop(e) {
      this.allowDrop(e);
      FriendListHandler.DeleteFriendGroupItem(
        e.dataTransfer.getData("socialLeadId"),
        e.dataTransfer.getData("trashCanGroupId"),
        this.staff.staffid
      );
      FriendListHandler.GetGroupFriendList(
        e.dataTransfer.getData("trashCanGroupId"),
        this.staff.staffid
      );
      this.$notify({
        title: "成功",
        message:
          "客戶" +
          e.dataTransfer.getData("socialLeadName") +
          "已成功從" +
          e.dataTransfer.getData("trashCanGroupName") +
          "好友群組中刪除",
        type: "success",
        position: "top-left"
      });
    },
    dragenter(e) {
      console.log("i am dragenter");
    },
    allowDrop(e) {
      e.preventDefault();
    },
    SelectClass() {
      if (isMobile) {
        return "friendList_M";
      } else {
        return "friendList";
      }
    },
    scrollHanle(evt) {}
  },
  computed: {
    AllFriendList() {
      return store.state.friendList;
    },
    FriendList: {
      get: function() {
        var unread = store.state.friendUnread;
        //更新好友訊息未讀
        if (unread != null && unread != undefined) {
          var obj = this.AllFriendList.filter(function(elem) {
            if (elem.socialLeadId == unread.socialLeadId) return elem;
          });

          if (obj.length > 0) {
            obj[0].messageDate = unread.messageDate;
            if (unread.UnreadCount > 999) obj[0].UnreadCount = "999+";
            else obj[0].UnreadCount = unread.UnreadCount;
          }
          //return _.orderBy(this.AllFriendList, "messageDate", "desc");
        }
        return this.AllFriendList;
      },
      set: function() {}
    }
  }
};
</script>
<style>
.listDesc .leadEnglishName {
  font-size: 14px;
  font-weight: bold;
  color: #523838;
  line-height: 1.3;
  word-break: break-word;
  white-space: normal;
  margin-bottom: 3px;
}
.dontShow {
  visibility: hidden;
}
.trashCanDiv {
  border-radius: 999em;
  margin-top: -150%;
  margin-left: 32%;
  width: 150px;
  height: 150px;
  background: #191616;
  position: absolute;
}
.trashCanImg {
  width: 100px;
  height: 100px;
  margin-left: 25px;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/FriendList.vue